export default __webpack_public_path__ + "static/media/TF_18.f14ac111.png";